module.exports = __webpack_public_path__ + "media/images/sports_icons/football-b137ace395a0d9d1aa0f1fb0029a1260.png";